import React, { useState, useEffect } from 'react';

const InternetConnectivity = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div className={`fixed top-0 left-0 w-full fs-0-675 b p-4 text-center text-white transition-all ${isOnline ? 'bg-success' : 'bg-danger'}`}>
      {isOnline ? '' : 'You are offline 😞'}
    </div>
  );
};

export default InternetConnectivity;
